export default "__VITE_ASSET__CJ2ji0Tl__"